import { gql } from '@apollo/client/core';

export const AUDIT_LOG_ENTRY_FIELDS = gql`
  fragment AuditLogEntryFields on AuditLogEntry {
    id
    createdAt
    verb
    change
    actor {
      id
      name
    }
    updates {
      field
      from
      to
    }
  }
`;
